import React from 'react';
/**
 * DjayAvatar part — arms per emotion (with small-size stubs fallback).
 * Verbatim extraction of the former `renderArms()`.
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface ArmsProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showFullArms: boolean;
  showArmStubs: boolean;
}
export function Arms({
  emotion,
  colors,
  showFullArms,
  showArmStubs
}: ArmsProps) {
  if (!showFullArms && !showArmStubs) return null;
  if (showArmStubs) return <g className="djay-arms-stubs" data-id="element-3072">
        <circle cx="38" cy="125" r="8" fill={colors.armColor} data-id="element-3073" />
        <circle cx="162" cy="125" r="8" fill={colors.armColor} data-id="element-3074" />
      </g>;
  switch (emotion) {
    case 'pointing':
      return <>
          <g className="djay-arm-left" data-id="element-3075">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3076" />
          </g>
          <g className="djay-arm-right" style={{
          transformOrigin: '150px 120px'
        }} data-id="element-3077">
            <ellipse cx="165" cy="120" rx="22" ry="12" fill={colors.armColor} transform="rotate(-10 165 120)" data-id="element-3078" />
            <path d="M175 118 L192 115" stroke={colors.armColor} strokeWidth="10" strokeLinecap="round" data-id="element-3079" />
            <path d="M175 118 L192 115" stroke={colors.armHighlight} strokeWidth="4" strokeLinecap="round" data-id="element-3080" />
            <ellipse cx="170" cy="118" rx="8" ry="6" fill={colors.armHighlight} transform="rotate(-10 170 118)" data-id="element-3081" />
          </g>
        </>;
    case 'celebrating':
    case 'excited':
    case 'proud':
      return <>
          <g className="djay-arm-left" data-id="element-3082">
            <ellipse cx="40" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(35 40 90)" data-id="element-3083" />
            <ellipse cx="32" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(35 32 75)" data-id="element-3084" />
          </g>
          <g className="djay-arm-right" data-id="element-3085">
            <ellipse cx="160" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(-35 160 90)" data-id="element-3086" />
            <ellipse cx="168" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-35 168 75)" data-id="element-3087" />
          </g>
        </>;
    case 'thinking':
      return <>
          <g className="djay-arm-left" data-id="element-3088">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3089" />
          </g>
          <g className="djay-arm-right" data-id="element-3090">
            <ellipse cx="135" cy="135" rx="14" ry="22" fill={colors.armColor} transform="rotate(-45 135 135)" data-id="element-3091" />
            <ellipse cx="125" cy="120" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-45 125 120)" data-id="element-3092" />
          </g>
        </>;
    case 'surprised':
      return <>
          <g className="djay-arm-left" data-id="element-3093">
            <ellipse cx="30" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(-20 30 125)" data-id="element-3094" />
          </g>
          <g className="djay-arm-right" data-id="element-3095">
            <ellipse cx="170" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(20 170 125)" data-id="element-3096" />
          </g>
        </>;
    case 'sleeping':
      return <>
          <g className="djay-arm-left" data-id="element-3097">
            <ellipse cx="55" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(20 55 145)" data-id="element-3098" />
          </g>
          <g className="djay-arm-right" data-id="element-3099">
            <ellipse cx="145" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(-20 145 145)" data-id="element-3100" />
          </g>
        </>;
    case 'encouraging':
      return <>
          <g className="djay-arm-left" data-id="element-3101">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3102" />
          </g>
          <g className="djay-arm-right" data-id="element-3103">
            <ellipse cx="165" cy="135" rx="20" ry="14" fill={colors.armColor} transform="rotate(-15 165 135)" data-id="element-3104" />
            <ellipse cx="175" cy="130" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-15 175 130)" data-id="element-3105" />
          </g>
        </>;
    case 'happy':
    default:
      return <>
          <g className="djay-arm-left" data-id="element-3106">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3107" />
            <ellipse cx="38" cy="118" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-20 38 118)" data-id="element-3108" />
          </g>
          <g className="djay-arm-right" data-id="element-3109">
            <ellipse cx="158" cy="130" rx="18" ry="22" fill={colors.armColor} transform="rotate(15 158 130)" data-id="element-3110" />
            <ellipse cx="154" cy="123" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(15 154 123)" data-id="element-3111" />
          </g>
        </>;
  }
}